import { useQuery } from "@tanstack/react-query";

import { listRegions } from "../api/lookups";
import type { PennRegion } from "@penn/web-common";

export function useRegions() {
  return useQuery<PennRegion[]>({
    queryKey: ["lookups", "regions"],
    queryFn: listRegions,
    staleTime: 5 * 60 * 1000,
  });
}
